import { useWidget } from '@telescope/cassini-hooks';
import { Button, Flex, Heading, Image, Link, Stack, useTheme } from '@telescope/cassini-ui';
import { Checkmark } from 'icons';
import { Countdown } from './Countdown';
import { TimeAndDate } from './TimeAndDate';
import { Share } from './Share';
import { AdUnit, Text } from 'components';
import { Open } from 'generated-types/widget';

interface ThankYouProps {
  isVoteAgainAllowed: boolean;
  onVoteAgain?: () => void;
  onViewVotes?: () => void;
}

export const ThankYou = ({ onVoteAgain, onViewVotes, isVoteAgainAllowed }: ThankYouProps) => {
  const theme = useTheme();
  const {
    data: { content, settings, styles = {} },
  } = useWidget<Open>({ select: (data) => data.snapshot.snapshot_views.thankYou });
  const colorScheme = theme.settings.defaultColorScheme;
  const {
    data: { ads },
  } = useWidget<Open>({ select: (data) => data.widget });

  return (
    <Flex className="ThankYou" direction={'column'} align="center" {...styles.root}>
      <Checkmark
        className="ThankYou__checkmark-icon"
        width="64px"
        height="64px"
        mb={5}
        fill={`${colorScheme}.500`}
        {...styles.checkmark}
      />

      <Heading className="ThankYou__heading" as="h1" size="lg" textAlign={'center'} mb={7} {...styles.headline}>
        {content.headline}
      </Heading>

      {settings.countdownClock.displayCountdown && (
        <Countdown content={content.countdownClock} settings={settings.countdownClock} styles={styles.countdownClock} />
      )}
      <Link className="ThankYou__sponsor-link" href={content.sponsorLink} target="_blank" {...styles.sponsorLink}>
        <Image className="ThankYou__sponsor-logo" src={content.sponsorLogo} alt="" mb={7} {...styles.sponsorLogo} />
      </Link>
      <Text allowMarkdown className="ThankYou__description" textAlign={'center'} mb={9} {...styles.description}>
        {content.description}
      </Text>

      {settings.timeAndDate.displayTimeAndDate && (
        <TimeAndDate content={content.timeAndDate} settings={settings.timeAndDate} styles={styles.timeAndDate} />
      )}

      <Stack spacing={4} mb={6}>
        <Button className="ThankYou__view-votes-btn" onClick={onViewVotes} {...styles.viewVotesBtn}>
          {content.buttons.viewVotes}
        </Button>
        {isVoteAgainAllowed && (
          <Button
            className="ThankYou__vote-again-btn"
            variant="solidInverse"
            onClick={onVoteAgain}
            {...styles?.voteAgainBtn}>
            {content.buttons.voteAgain}
          </Button>
        )}
      </Stack>
      <Share content={content.socialSharing} settings={settings.socialSharing} />
      <AdUnit mt={5} size="mobileBanner" {...ads.thanksModal.mobileBanner} />
    </Flex>
  );
};
